<!-- FileUpload.vue -->
<template>
  <div class="filepond-container">
    <div class="filepond-content">
      <FilePond ref="pond" labelIdle="Clique para anexar arquivos" :allowMultiple="true" :maxFileSize="'5MB'"
        acceptedFileTypes="image/jpeg, image/png, application/pdf" :files="myFiles" @init="handleFilePondInit"
        @updatefiles="handleFileUpdate" />

      <small>Máximo 5MB por arquivo</small>
    </div>
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import 'filepond/dist/filepond.min.css'

const FilePond = vueFilePond(
  FilePondPluginFileValidateSize
)

export default {
  name: 'FileUpload',
  components: { FilePond },
  data() {
    return {
      myFiles: [],
    }
  },
  methods: {
    handleFilePondInit() {
      console.log('FilePond has initialized')
      // Você pode acessar a instância do FilePond via this.$refs.pond
    },
    handleFileUpdate(files) {
      this.myFiles = files
      this.$emit('input', files) // Emite os arquivos para v-model ou uso em componentes pai
    },
  },
}
</script>

<style>
.filepond-container {
  padding: 0.625rem;
  background-color: #EFF6FF;
  border: 1px solid #EAEAEA;
  border-radius: 4px;
}

.filepond-content {
  padding: 1.5rem;
  background-color: #ffffff;
  border: 1px dashed #D1D5DB;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.filepond-content>small {
  flex: 1;
  display: flex;
  justify-content: center;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 0.75rem;
  line-height: 100%;
  letter-spacing: 0px;
  color: #8D8D8D;
}

.filepond--panel-root {
  background-color: #ffffff;
  padding-bottom: 1rem;
}
</style>